import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.stockLocationCategoriesPage.title, 'Stock Location Categories'),
};
